/**
 * A class to handle equalizing heights/widths
 */

var Equalizer = function( itemsToEqualize ){

	this.itemsToEqualize = itemsToEqualize;

};

Equalizer.prototype.init = function(){

	var self = this;

	console.log('equalizer init');

};

Equalizer.prototype.equalizeHeights = function() {

	var maxHeight = 0;

	this.itemsToEqualize.each(function() {

		$(this).css('min-height', '0px');

		var itemHeight = $(this).outerHeight();

		if (itemHeight > maxHeight)
		{
			maxHeight = itemHeight;
		}

	});

	this.itemsToEqualize.css('min-height', maxHeight);

};

Equalizer.prototype.equalizeWidths = function() {

	var maxWidth = 0;

	this.itemsToEqualize.each(function() {

		$(this).css('min-width', '0px');

		var itemWidth = $(this).outerWidth();

		if (itemWidth > maxWidth)
		{
			maxWidth = itemWidth;
		}

	});

	this.itemsToEqualize.css('min-width', maxWidth);

};

export default Equalizer;
